import { get, post } from "../httpInterceptor";

//fetching id,segcode,segdescription from api,listing data
export const getAllLevel = () => {
  return get(`/sarvagram-credit/masternew/getlevelmaster`).then((res) => {
    console.log("RESPONSE :: getAllLevel ::: ", res);
    return res;
  });
};
